"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CotterJwtToken_1 = __importDefault(require("./CotterJwtToken"));
class CotterIDToken extends CotterJwtToken_1.default {
    constructor(token) {
        super(token);
    }
    decodePayload() {
        var obj = super.decodePayload();
        return obj;
    }
    getAuthTime() {
        return this.payload.auth_time;
    }
    getIdentifier() {
        return this.payload.identifier;
    }
    getID() {
        return this.payload.sub;
    }
    getClientUserID() {
        return this.payload.client_user_id;
    }
}
exports.default = CotterIDToken;
